// extracted by mini-css-extract-plugin
export default {"wave":"loader_wave__9Ane9","dot":"loader_dot__Vu1J4"};